import React from 'react'
import { View, Text, StyleSheet, StyleProp, ViewStyle } from 'react-native'

import {
  BORDER_STYLES,
  COMMON_STYLES,
  TEXT_STYLES,
  TYPOGRAPHY,
  VARIANTS_STYLES,
} from '@dehaat/dds'
import { DIMENSION_WIDTH } from 'app/utils/common'

interface Props {
  title: string
  containerStyle?: StyleProp<ViewStyle>
}

const EmptySectionCard = ({ title, containerStyle }: Props) => {
  return (
    <View
      style={[
        COMMON_STYLES.flex1,
        COMMON_STYLES.alignItemsCenter,
        COMMON_STYLES.justifyCenter,
        COMMON_STYLES.b1,
        BORDER_STYLES.borderNeutral40,
        COMMON_STYLES.br1,
        styles.dashed,
        { width: DIMENSION_WIDTH - 48 },
        styles.minHeight,
        styles.maxWidth,
        containerStyle,
      ]}
    >
      <Text
        style={[
          TYPOGRAPHY.TEXT1,
          VARIANTS_STYLES.MEDIUM,
          TEXT_STYLES.textNeutral80,
        ]}
      >
        {title}
      </Text>
    </View>
  )
}

const styles = StyleSheet.create({
  dashed: {
    borderStyle: 'dashed',
  },
  minHeight: {
    minHeight: 80,
  },
  maxWidth: {
    maxWidth: 934,
  },
})

export default EmptySectionCard
